import { MenuOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderSection = styled('header')`
  padding: 1rem 0.5rem;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled('div')`
  display: inline-block;
  text-align: center;
`;

export const NavbarLinkRoot = styled('div')`
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: space-between;

  button {
    color: #161616;
    min-width: 100px;
    height: 100%;
    padding: 10px;
    font-size: 19px;
    cursor: pointer;
    border-radius: 4px;
    border: none;
  }
`;

export const RefreshBtn = styled('button')`
  background-color: #0f0f0f;
  color: #fff !important;
  border: 1px solid #fff !important;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: black !important;
    border: 1px solid black;
    background-color: #fff;
  }
`;
export const WalletInfoText = styled('p')`
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px;
  height: 100%;
  margin: 0;
  svg {
    fill: #fff;
    height: 30px;
    width: 30px;
  }
`;

export const CustomNavLink = styled('div')`
  width: 203px;
  display: inline-block;

  a {
    color: #fff !important;
  }

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const ContactWrapper = styled('div')<any>`
  cursor: pointer;
  width: ${(p) => (p.width ? '100%' : '110px')};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
`;

export const Burger = styled('div')`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled('div')`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled('h5')`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #fff;
  transition: color 0.2s ease-in;
  margin: 0;
  min-width: 80px;

  button {
    margin: 0;
    border: 2px solid #fff;
    a {
      color: #fff;
    }
  }

  .withBox {
    color: #fff;
  }

  :hover {
    .withBox {
      color: #2e186a;
    }
  }

  a {
    color: #fff;
  }
  :hover a {
    color: #2e186a;
  }
  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled('span')`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)<any>`
  font-size: 22px;
`;

export const Span = styled('span')`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    text-underline-position: under;
    text-decoration: #fff wavy underline;
  }
`;
